import { message } from 'antd';
import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounce } from 'use-debounce';
import { transport } from '../../../utils/constants';
import { getColor, getName, getToken, isRpcError, setAvas } from '../../../utils/helper';
import Ava from '../Ava/Ava';
import './Search.scss';
import { Account_Info } from '../../../generated/mlmbox/types/account';
import { NetworkClient } from '../../../generated/mlmbox/client/network/network.client';

interface ISearch {
    placeholder?: string;
    setSelect?: Function;
    team?: boolean;
}

const Search: FC<ISearch> = ({ placeholder, setSelect, team = false }) => {
    const [searching, setSearching] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue] = useDebounce(searchValue, 500);
    const [searchList, setSearchList] = useState<Account_Info[]>([]);
    const { t } = useTranslation();

    const networkClient = new NetworkClient(transport);

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 300);
    }, []);

    function teamSearch() {
        if (!searchValue.length) return;

        networkClient
            .memberSearch({ limit: 3, loginPrefix: debouncedValue, filterChannels: [1] }, { meta: { authorization: getToken() } })
            .then(async ({ status, response }) => {
                console.log(response);
                if (status.code === 'OK') {
                    const info = response.items;
                    if (info) await setAvas(info);
                    setSearchList(response.items);
                    setSearching(false);
                }
            })
            .catch((error) => {
                if (isRpcError(error)) {
                    message.destroy();
                    if (error.message === 'LOGIN_FORMAT_UNSUPPORTED') message.error(t('errors.login_format'));
                    setSearching(false);
                }
            });
    }

    function search() {
        if (!searchValue.length) return;

        networkClient
            .teamSearch({ limit: 3, loginPrefix: searchValue, filterChannels: [1] }, { meta: { authorization: getToken() } })
            .then(async ({ status, response }) => {
                if (status.code === 'OK') {
                    const info = response.items;
                    if (info) await setAvas(info);
                    setSearchList(response.items);
                    setSearching(false);
                }
            })
            .catch((error) => {
                if (isRpcError(error)) {
                    message.destroy();
                    if (error.message === 'LOGIN_FORMAT_UNSUPPORTED') message.error(t('errors.login_format'));
                    setSearching(false);
                }
            });
    }

    useEffect(() => {
        if (!searchValue.length) {
            setSearchList([]);
            setSearching(false);
            return;
        }
        setSearching(true);

        if (team) search();
        else teamSearch();
    }, [debouncedValue]);

    return (
        <div className="search">
            <input
                ref={inputRef}
                type="text"
                placeholder={placeholder ? placeholder : ''}
                value={searchValue}
                autoComplete="off"
                onChange={(e) => {
                    setSearching(true);
                    setSearchValue(e.target.value);
                }}
            />
            <ul>
                <li>{t('login.settings.help_list.item_1')}</li>
                <li>{t('login.settings.help_list.item_2')}</li>
                <li>{t('login.settings.help_list.item_3')}</li>
            </ul>
            {searching && (
                <div className="load">
                    <div className="spinner small loading"></div>
                </div>
            )}
            <div className="search__dropdown">
                {searchList.map((account) => (
                    <div
                        onClick={() => {
                            if (!setSelect) return;
                            if (team) {
                                setSelect(account.account?.id);
                            } else {
                                setSelect(account);
                            }
                        }}
                        className="dropdown__item"
                        key={account.account?.id}>
                        <Ava
                            width="40px"
                            height="40px"
                            entityId={account.profile?.ava?.entityId}
                            collectionId={account.profile?.ava?.collectionId}
                            borderColor={getColor(account.relationship)}
                        />
                        <div className="dropdown__item--data">
                            <h1>{account.profile?.telegram && getName(account)}</h1>
                            <p>@{account.account?.login ? account.account.login : '-'}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Search;
